module.exports = __webpack_public_path__ + "static/media/videoTitle.c0886963.mp3";